export const DIFF_BAND_TRUNCATION_SERIES_NAME = '__truncation_band_diff__';
export const UPPER_BAND_TRUNCATION_SERIES_NAME = 'All Results (Upper Band)';
export const LOWER_BAND_TRUNCATION_SERIES_NAME = 'All Results (Lower Band)';
export const STACKED_BAND_TRUNCATION_SERIES_NAME = 'Truncated series total';

const truncationBandLabels = ['stack', 'lower', 'upper'] as const;

export type TruncationBandLabel = (typeof truncationBandLabels)[number];

export function isValidTruncationBandLabel(value?: string): value is TruncationBandLabel {
  return truncationBandLabels.includes(value as TruncationBandLabel);
}

export type TruncationBandMaps = Record<TruncationBandLabel, Map<number, number>>;

export type TruncationBandTotals = {
  maps: TruncationBandMaps;
  band: TruncationBandLabel;
};
